import moment from "moment";
import {axiosLoc, axiosApi} from "./common";

/**
 * 기준 시간
 * @returns
 */
export const lsttm = function() {
    return new Promise((resolve, reject) => {
        axiosApi.post("/common/lsttm").then((result) => {
            const currentTime = moment(result.lsttm, "YYYYMMDDHHmm", true);
            // const cloneCurrent = Clone.cloneDeep(currentTime);
            const lsttm = currentTime.format('YYYYMMDDHHmm')
            const previousTime = currentTime.subtract(10, 'minute').format('YYYYMMDDHHmm');
            const format = currentTime.format('YYYY-MM-DD HH:mm');

            resolve(new Array({lsttm: lsttm, current: currentTime, previou: previousTime, format: format}))
        }).catch((e)=> {
            reject(e.message)
        })
    });
}

/**
 * 관리기관 select 박스 생성
 */
export const initAgcif = function(){

     axiosApi.post('/common/cdifdtl/01') // 01번 -> 관리기관코드 리스트
        .then(info => {
            try{
                let default_ = document.createElement('option');
                default_.value = 'all'
                default_.innerText = 'Agency'

                const agclist = document.getElementById('agclist');
                agclist.appendChild(default_)
                info.forEach((val, idx) => {
                    const option = document.createElement('option')
                    option.value = val.dtlcd;
                    option.innerText = val.cpt;
                    agclist.appendChild(option)
                })

                default_ = document.createElement('option');
                default_.value = 'all'
                default_.innerText = 'Agency'

                const popAgclist = document.getElementById('popAgclist');
                popAgclist.appendChild(default_)
                info.forEach((val, idx) => {
                    const option = document.createElement('option')
                    option.value = val.dtlcd;
                    option.innerText = val.cpt;
                    popAgclist.appendChild(option)
                })

            }catch(err){

            }
        })
}

/**
 * 유역 select 박스 생성
 */
export const initBasinif = function(){

    try{
        const bsnlist = document.getElementById('bsnlist');
        if(bsnlist){
            while(bsnlist.firstChild) {
                bsnlist.removeChild(bsnlist.firstChild);
            }
        }

        const popBsnlist = document.getElementById('popBsnlist');
        if(popBsnlist){
            while(popBsnlist.firstChild) {
                popBsnlist.removeChild(popBsnlist.firstChild);
            }
        }
    }catch(err){

    }

    axiosApi.post('/basin/Fbs/Info')
        .then(info => {
            try{
                let default_ = document.createElement('option');
                default_.value = 'all'
                default_.innerText = 'Basin'

                const bsnlist = document.getElementById('bsnlist');
                bsnlist.appendChild(default_)
                info.forEach((val, idx) => {
                    const option = document.createElement('option')
                    option.value = val.fbscd;
                    option.innerText = val.fbsnm;
                    bsnlist.appendChild(option)
                })

                default_ = document.createElement('option');
                default_.value = 'all'
                default_.innerText = 'Basin'

                const popBsnlist = document.getElementById('popBsnlist');
                popBsnlist.appendChild(default_)
                info.forEach((val, idx) => {
                    const option = document.createElement('option')
                    option.value = val.fbscd;
                    option.innerText = val.fbsnm;
                    popBsnlist.appendChild(option)
                })
            }catch(err){

            }
        })
}